import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Voucher } from '../models/voucher';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  private itemDoc: AngularFirestoreDocument<Voucher>;
  private item: Observable<Voucher>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Voucher>('sbccv_vouchers', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectVouchers(sponsor_id: any, product_id: any) {
    return this.db.collection<Voucher>('sbccv_vouchers', ref => ref
    .where('sponsor_id', '==', sponsor_id)
    .where('product_id', '==', product_id)
    .orderBy('name', 'asc')).snapshotChanges();            
}

  selectById(id) {
    this.itemDoc = this.db.doc<Voucher>('sbccv_vouchers/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: Voucher) {
    return this.db.collection('sbccv_vouchers').add(Object.assign({}, entity));
  }

  update(entity: Voucher) {
    return this.db.collection('sbccv_vouchers').doc(entity.id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_vouchers').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string = "Erro"
    switch (errorsCode) {
      case "":
        msgError = "Erro"
        break;
    }
    return msgError
  }

}



